import type { Employer } from '@/shared/api/model/employer';
import type { User } from '@/shared/api/model/user';
import { create } from 'zustand';

interface UserState {
  user: User | null;
  employer: Employer | null;
  setUser: (user: User) => void;
  setEmployer: (employer: Employer) => void;
}

export const useUser = create<UserState>()((set) => ({
  user: null,
  employer: null,
  setUser: (user: User) => set(() => ({ user })),
  setEmployer: (employer: Employer) => set(() => ({ employer })),
}));
